import { ParagraphElement, type TParagraphElement } from '@/paragraphElement';
import type { SerializableNode } from '@/serializer';
import { SerializeTextLeaf, type TTextLeaf } from '@/textLeaf';
import type { ContentTag } from '@/types';
import type { JSONContent } from '@tiptap/core';

interface Props {
  tags: ContentTag[];
  node: JSONContent & SerializableNode;
}

export const ContentTags = ({ tags, node, ...props }: Props) => {
  if (!tags || tags.length === 0) return null;

  if (node?.attrs?.postTagsTruncateListEnabled) {
    const tagsCount = tags.length;
    const tagsToShow = tags[0];
    const tagsRemaining = tagsCount - 1;
    const textNode = {
      ...node?.content?.[0],
      text: tagsToShow.display,
    } as TTextLeaf;

    return (
      <div className="relative flex flex-wrap" {...props} style={{ gap: node?.attrs?.postTagsGap ?? '4px' }}>
        <ParagraphElement element={node as TParagraphElement}>
          <SerializeTextLeaf leaf={textNode} />
        </ParagraphElement>
        {tagsRemaining > 0 && (
          <ParagraphElement element={node as TParagraphElement}>
            <SerializeTextLeaf
              leaf={{
                ...textNode,
                text: `+${tagsRemaining}`,
              }}
            />
          </ParagraphElement>
        )}
      </div>
    );
  }

  return (
    <div className="relative flex flex-wrap" {...props} style={{ gap: node?.attrs?.postTagsGap ?? '4px' }}>
      {tags.map((tag) => {
        const textNode = {
          ...node?.content?.[0],
          text: tag.display,
        } as TTextLeaf;

        return (
          <ParagraphElement key={tag.id} element={node as TParagraphElement}>
            <SerializeTextLeaf leaf={textNode} />
          </ParagraphElement>
        );
      })}
    </div>
  );
};
